import { PHSelfEmpSmallBusIntentOptions } from '../../enums/PHSelfEmpSmallBusIntentOptions';
import { GenericCheckboxStep } from '../steps';

function PHSelfEmpSmallBusIntentStep() {
  return (
    <GenericCheckboxStep
      title="How can a tax pro best support you?"
      subtitle="Select all that apply."
      checkboxOptions={PHSelfEmpSmallBusIntentOptions}
      referralFieldName="ph_self_employed_small_business_intent"
    />
  );
}

export { PHSelfEmpSmallBusIntentStep };
